// PDP interactivity: gallery, once/subscribe pricing, quantity, ship meter, sticky bar.
(function () {
  var root = document.querySelector('[data-pdp]');
  if (!root) return;

  var dataEl = document.querySelector('[data-pdp-json]');
  var data = {};
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var variantsById = {};
  data.variants.forEach(function (v) { variantsById[v.id] = v; });

  // One radio group per option (Colour, Size), not one select holding all 28
  // combinations.
  var optGroups = Array.prototype.slice.call(root.querySelectorAll('.vopt'));
  var idInput = root.querySelector('[data-variant-id]');
  var optErr = root.querySelector('[data-opt-err]');
  var planInput = root.querySelector('[data-selling-plan]');
  var bigPrice = root.querySelector('[data-big-price]');
  var subAmt = root.querySelector('[data-sub-amt]');
  var onceAmt = root.querySelector('.opt[data-mode="once"] .amt');
  var atcButtons = document.querySelectorAll('[data-atc]');
  var qtyInput = root.querySelector('[data-qty]');
  var shipMsg = root.querySelector('[data-ship-msg]');
  var shipBar = root.querySelector('[data-ship-bar]');
  var stickyNote = document.querySelector('[data-sticky-note]');

  // Always 'once'. This used to default to 'sub' whenever the product had a
  // selling plan, so adding to cart without reading the buy box started a
  // recurring charge. Subscribing is a decision the shopper makes, not one
  // they opt out of.
  var mode = 'once';
  var planId = null;
  var firstCad = root.querySelector('.cad');
  if (firstCad) planId = firstCad.dataset.plan;

  // The values currently checked, in option order.
  function chosen() {
    return optGroups.map(function (g) {
      var r = g.querySelector('[data-opt]:checked');
      return r ? r.value : null;
    });
  }
  function findVariant(want) {
    for (var i = 0; i < data.variants.length; i++) {
      var v = data.variants[i];
      if (!v.options) continue;
      var hit = true;
      for (var j = 0; j < want.length; j++) {
        if (want[j] !== null && v.options[j] !== want[j]) { hit = false; break; }
      }
      if (hit) return v;
    }
    return null;
  }
  function currentVariant() {
    if (!optGroups.length) return variantsById[idInput && idInput.value] || data.variants[0];
    return findVariant(chosen()) || data.variants[0];
  }
  function money(c) { return '$' + (c / 100).toFixed(2); }

  function unitPrice() {
    var v = currentVariant();
    if (mode === 'sub' && planId && v.plans[planId] != null) return v.plans[planId];
    return v.price;
  }
  function planName() {
    var b = root.querySelector('.cad[data-plan="' + planId + '"]');
    return b ? b.textContent.trim() : '';
  }

  function render() {
    var v = currentVariant();
    var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
    var unit = unitPrice();
    var total = unit * qty;

    if (bigPrice) bigPrice.textContent = money(unit);
    if (onceAmt) onceAmt.textContent = money(v.price);
    if (subAmt && planId && v.plans[planId] != null) subAmt.textContent = money(v.plans[planId]);

    atcButtons.forEach(function (b) {
      // Disabled now also means "this colour/size combination is gone", so the
      // label has to say so rather than keep the last price it showed.
      b.textContent = b.disabled ? 'Sold out' : 'Add to cart \u00b7 ' + money(total);
    });
    if (stickyNote) stickyNote.textContent = mode === 'sub' ? ('Subscribe · ' + planName().toLowerCase()) : 'One-time';

    // selling plan hidden input
    if (planInput) planInput.value = (mode === 'sub' && planId) ? planId : '';

    // ship meter
    if (shipMsg && shipBar) {
      if (mode === 'sub') {
        shipMsg.textContent = 'Free shipping on every club order';
        shipBar.style.setProperty('--pct', 100);
      } else {
        // Count what is already in the cart, not this line alone.
        var basket = data.cartSubtotal || 0;
        var rem = Math.max(0, data.threshold - total - basket);
        shipMsg.textContent = rem > 0 ? money(rem) + ' more for free shipping' : 'Free shipping unlocked';
        shipBar.style.setProperty('--pct', Math.min(100, ((total + basket) / data.threshold) * 100));
      }
    }
  }

  // Purchase option toggle. Driven by the radios' change event rather than a
  // click on the label, so keyboard selection (arrow keys) works and assistive
  // tech announces the choice. Clicking the label still fires change.
  function selectOpt(o) {
    root.querySelectorAll('.opt').forEach(function (x) { x.classList.remove('on'); });
    o.classList.add('on');
    mode = o.dataset.mode;
    render();
  }

  root.querySelectorAll('.opt .opt-r').forEach(function (r) {
    r.addEventListener('change', function () {
      if (r.checked) selectOpt(r.closest('.opt'));
    });
  });

  // cadence
  root.querySelectorAll('.cad').forEach(function (c) {
    c.addEventListener('click', function (e) {
      e.preventDefault();
      root.querySelectorAll('.cad').forEach(function (x) { x.classList.remove('on'); });
      c.classList.add('on');
      planId = c.dataset.plan;
      // Choosing a cadence is an explicit act of subscribing, so move the radio
      // with it — otherwise the visible selection and the submitted value drift.
      var subOpt = root.querySelector('.opt[data-mode="sub"]');
      if (subOpt) {
        var subRadio = subOpt.querySelector('.opt-r');
        if (subRadio) subRadio.checked = true;
        selectOpt(subOpt);
        return;
      }
      render();
    });
  });

  // quantity
  var minus = root.querySelector('[data-qty-minus]');
  var plus = root.querySelector('[data-qty-plus]');
  if (minus) minus.addEventListener('click', function () { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); render(); });
  if (plus) plus.addEventListener('click', function () { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; render(); });
  if (qtyInput) qtyInput.addEventListener('change', render);

  // gallery
  function showMedia(idx) {
    var found = false;
    root.querySelectorAll('.gal-thumbs button').forEach(function (x) {
      var on = x.dataset.th === String(idx);
      if (on) found = true;
      x.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    if (!found && root.querySelector('.gal-thumbs')) return;
    root.querySelectorAll('.gal-fig').forEach(function (f) {
      f.classList.toggle('on', f.dataset.fig === String(idx));
    });
    var strip = root.querySelector('.gal-thumbs');
    var sel = strip && strip.querySelector('[aria-selected="true"]');
    if (sel && sel.scrollIntoView) sel.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  }
  root.querySelectorAll('.gal-thumbs button').forEach(function (b) {
    b.addEventListener('click', function () { showMedia(b.dataset.th); });
  });

  // Variant change. Choosing "Heather Navy" used to leave a lime green tee on
  // screen, because nothing connected the selector to the gallery.
  function grey() {
    // A value is struck through when no available variant carries it alongside
    // the other current choices, so the shopper never walks into a dead end.
    var cur = chosen();
    optGroups.forEach(function (g, gi) {
      g.querySelectorAll('[data-opt]').forEach(function (r) {
        if (r.checked) { r.disabled = false; return; }
        var want = cur.slice();
        want[gi] = r.value;
        var v = findVariant(want);
        r.disabled = !v || !v.available;
      });
    });
  }
  function onOptChange(changed) {
    var want = chosen();
    var v = findVariant(want);
    // Heather Navy is only made in S/M/L. Picking it while XS was selected used
    // to leave the shopper on a dead combination reading "Sold out". Honour the
    // thing they just clicked and carry the rest to the nearest option that
    // exists, so a colour click always shows that colour.
    if ((!v || !v.available) && changed != null) {
      var keep = want[changed];
      for (var i = 0; i < data.variants.length; i++) {
        var c = data.variants[i];
        if (c.options && c.options[changed] === keep && c.available) { v = c; break; }
      }
      if (v) {
        optGroups.forEach(function (g, gi) {
          var r = g.querySelector('[data-opt][value="' + CSS.escape(v.options[gi]) + '"]');
          if (r) r.checked = true;
        });
      }
    }
    if (!v) v = findVariant(chosen());
    grey();
    if (optErr) optErr.hidden = !!(v && v.available);
    if (idInput && v) idInput.value = v.id;
    atcButtons.forEach(function (b) { b.disabled = !v || !v.available; });
    if (v && v.mediaIndex >= 0) showMedia(v.mediaIndex);
    render();
  }
  optGroups.forEach(function (g, gi) {
    g.querySelectorAll('[data-opt]').forEach(function (r) {
      r.addEventListener('change', function () { onOptChange(gi); });
    });
  });
  // Sync on load too: the gallery opened on media 0 while the preselected
  // variant's own photo was media 5, which is the mismatch this whole block exists
  // to remove.
  if (optGroups.length) { onOptChange(null); }

  // sticky
  var sticky = document.querySelector('[data-sticky]');
  var sentinel = root.querySelector('.atc-row');
  if (sticky && sentinel && 'IntersectionObserver' in window) {
    // Show the sticky bar whenever the real add-to-cart is not essentially on
    // screen, in EITHER direction.
    //
    // The old test was `!isIntersecting && boundingClientRect.top < 0`, i.e. only
    // once the button had scrolled ABOVE the viewport. On mobile the button starts
    // BELOW the fold on every food PDP (measured: thyme 833px, ghost chiles 871px
    // against an 844px viewport), so top was positive, the bar never fired, and the
    // page opened with no buy control visible at all. threshold 0 made it worse:
    // 11 visible pixels of a 62px button counted as "visible".
    new IntersectionObserver(function (en) {
      sticky.classList.toggle('on', !en[0].isIntersecting || en[0].intersectionRatio < 0.9);
    }, { threshold: [0, 0.9, 1] }).observe(sentinel);
  }

  render();
})();
